// extracted by mini-css-extract-plugin
export default {"container":"MainLayout_container__K04QT","appFrame":"MainLayout_appFrame__x1hWu","content":"MainLayout_content__sm2ui"};